import React, { useState, useEffect, useContext } from 'react'
import { Box } from "grommet"
import UserContext from '../../context/UserContext'

import HealthStatusEnv from '../health2/HealthStatusEnv'

import { gql, useSubscription } from '@apollo/client';

import styled from 'styled-components'
import envConfig from '../../utils/envConfig'

const BoxScrollbar = styled(Box)`
    /* width */
    ::-webkit-scrollbar {
    height: 10px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
    background: brand; 
    }
    
    /* Handle */
    ::-webkit-scrollbar-thumb {
    background: #EDEDED; 
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
    background: #777; 
    }
`

const ENVIRONMENT_QUERY = gql`
subscription ($personId: bigint!) {
    puser_environment(where: {puser: {personId: {_eq: $personId}}}, order_by: {environment: {name: asc}}) {
        environment {
            name
        }
    }
}
`

const HEALTH_STATUS_QUERY = gql`
subscription {
    healthstatus(order_by: {env: asc}) {
        env
        down
        partial
        up
        scheduled_down
    }
}
`

const EnvSelect = ({ envSelected, handleEnvSelect }) => {

    const [envList, setEnvList] = useState([])
    const userToken = useContext(UserContext)
    const liteMode = envConfig[process.env.REACT_APP_ENVIRONMENT]['lite']

    const { data, loading } = useSubscription(ENVIRONMENT_QUERY, {
        variables: { personId: liteMode ? -1 :userToken.personId },
    })

    const healthData = useSubscription(HEALTH_STATUS_QUERY)

    useEffect(() => {
        // console.log('[EnvSelect useEffect]', data)
        if (!loading && data && data.puser_environment && data.puser_environment.length > 0) {
            const _envList = data.puser_environment.reduce((acc, env) => {
                acc.push(env.environment.name)
                return acc
            }, [])
            setEnvList(_envList)
        }
    }, [data, loading])

    // Prevent ReRender
    const [healthDataRender, sethealthDataRender] = useState([])
    useEffect(() => {
        if (!loading && !healthData.loading && healthData.data && healthData.data.healthstatus) {
            let tempResult = []
            healthData.data.healthstatus.forEach(statusbyenv => {
                if (envList.includes(statusbyenv.env)) {
                    tempResult.push(statusbyenv)
                }
            })
            sethealthDataRender(tempResult)
        }
    }, [healthData.data, healthData.loading, envList, loading])

    return (

        <>
            <BoxScrollbar
                fill="horizontal"
                flex={false}
                direction='row' pad='xxsmall' gap='xsmall' margin='none' alignSelf='start' alignContent='start'
                overflow='auto'
                name="envBoxScrollbar"
                align='start' justify='start' background="brand">

                {healthDataRender && healthDataRender.length > 0 && healthDataRender.map(statusbyenv => {
                    return (
                        <HealthStatusEnv key={statusbyenv.env} envName={statusbyenv.env} envSelected={envSelected}
                            handleEnvSelect={handleEnvSelect}
                            up={statusbyenv.up}
                            partial={statusbyenv.partial}
                            down={statusbyenv.down}
                            scheduled_down={statusbyenv.scheduled_down}
                        />
                    )
                }

                )}
            </BoxScrollbar>
        </>
    )
}

export default EnvSelect